import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const PaymentsAPI = {
  meterSummary: async(payload: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/meter-summary', JSON.stringify(payload))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getMeterInvoice: async(payload: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/meter-invoice', JSON.stringify(payload))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  upcomingInvoice: async(payload: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/retrieve-upcoming-invoice', JSON.stringify(payload))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  updateMeter: async(payload: any, cus_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/update-meter/${cus_id}`, JSON.stringify(payload))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createCustomer: async(customerObj: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/customers', JSON.stringify(customerObj))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  deleteCustomer: async(cus_id: string): Promise<any> =>
    (await initAxios())
      ?.delete(`/payments/customer/${cus_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  updateCustomerEmail: async(
    cus_id: string,
    user_email: string,
  ): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/customers/${cus_id}/update/${user_email}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getCustomerByEmail: async(email: string): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/customers/${email}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getCustomerPaymentMethods: async(cus_id: string): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/payment-methods/${cus_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getPaymentMethodById: async(cus_id: string, pay_id: string): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/payment-methods/${cus_id}/${pay_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  changeDefaultPayment: async(cus_id: string, pay_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/default-payment/${cus_id}/${pay_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  deletePayment: async(pay_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/delete-method/${pay_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  cancelSubscription: async(sub_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/cancel-now-subscription/${sub_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  cancelSubAtPeriodEnd: async(sub_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/cancel-subscription/${sub_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  renewCanceledSub: async(sub_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/renew-subscription/${sub_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  updateSubQuantity: async(subUpdates: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/subscriptions', JSON.stringify(subUpdates))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  updateSubPayment: async(sub_id: string, payMethod: any): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/method/${sub_id}`, JSON.stringify(payMethod))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  changeAPIPlan: async(subUpdates: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/api-plans', JSON.stringify(subUpdates))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  changePlan: async(subUpdates: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/plans', JSON.stringify(subUpdates))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  previewSubPayment: async(
    sub_id: string,
    cus_id: string,
    price_id: string,
    quantity: any,
  ): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/preview/${sub_id}/${cus_id}/${price_id}/${quantity}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  previewSubChange: async(
    sub_id: string,
    cus_id: string,
    price_id: string,
    quantity: any,
    meterPayload: any,
  ): Promise<any> =>
    (await initAxios())
      ?.post(
        `/payments/preview/sub-change/${sub_id}/${cus_id}/${price_id}/${quantity}`,
        JSON.stringify(meterPayload),
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  previewCheckout: async(
    cus_id: string,
    price_id: string,
    quantity: any,
  ): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/preview-checkout/${cus_id}/${price_id}/${quantity}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  listCustomerInvoices: async(cus_id: string): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/customers/${cus_id}/invoices`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getProducts: async(): Promise<any> =>
    (await initAxios())
      ?.get('/payments/products')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getProductById: async(prod_id: string): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/products/${prod_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getPrices: async(): Promise<any> =>
    (await initAxios())
      ?.get('/payments/prices')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createSetupIntent: async(setupIntentObj: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/setup-intent', JSON.stringify(setupIntentObj))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  confirmSetupIntent: async(setupIntentObj: any): Promise<any> =>
    (await initAxios())
      ?.post('/payments/confirm-setup-intent', JSON.stringify(setupIntentObj))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createCheckoutSession: async(
    lineItemsAndMode: any,
    cus_id: string,
  ): Promise<any> =>
    (await initAxios())
      ?.post(
        `/payments/checkout-session/${cus_id}`,
        JSON.stringify(lineItemsAndMode),
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createCustomerPortalSession: async(cus_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/customer-portal-session/${cus_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createSubUpdatePortalSession: async(
    cus_id: string,
    sub_id: string,
    subItems: any,
  ): Promise<any> =>
    (await initAxios())
      ?.post(
        `/payments/subscription-update-session/${cus_id}/${sub_id}`,
        JSON.stringify(subItems),
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createSubCancelSession: async(
    cus_id: string,
    sub_id: string,
  ): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/subscription-cancel-session/${cus_id}/${sub_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getCheckoutSession: async(session_id: string): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/checkout/${session_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getSubSchedule: async(sched_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/subscription-schedule/${sched_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  releaseSubSchedule: async(sched_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/subscription-schedule/release/${sched_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  cancelSubSchedule: async(sched_id: string): Promise<any> =>
    (await initAxios())
      ?.post(`/payments/subscription-schedule/cancel/${sched_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createSubSchedule: async(cus_id: string, subData: any): Promise<any> =>
    (await initAxios())
      ?.post(
        `/payments/subscription-schedule/create/${cus_id}`,
        JSON.stringify(subData),
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createSubscription: async(
    cus_id: string,
    itemsWithPrice: any,
    pay_method: string,
  ): Promise<any> =>
    (await initAxios())
      ?.post(
        `/payments/subscriptions/${cus_id}/${pay_method}`,
        JSON.stringify(itemsWithPrice),
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  autoStartTrial: async(
    user_id: string,
    cus_id: string,
    price_id: string,
    teamObj: any,
  ): Promise<any> =>
    (await initAxios())
      ?.post(
        `/payments/auto-start-trial/${user_id}/${cus_id}/${price_id}`,
        JSON.stringify(teamObj),
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  subscribeEntitiesPublicAPI: async(body: {
    email: string;
    team_name: string;
    payment_method: string;
  }): Promise<any> =>
    (await initAxios(process.env.REACT_APP_PUBLIC_API_URL))
      ?.post('/api/v1/subscribe/entities', body)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  subscribeCommoditiesPublicAPI: async(
    body: {
      email: string;
      team_name: string;
      payment_method: string;
    }): Promise<any> =>
    (await initAxios(process.env.REACT_APP_PUBLIC_API_URL))
      ?.post('/api/v1/subscribe/commodities', body)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  shouldStartMobileUserWebTrial: async(
    user_id: string,
    cus_id: string,
    price_id: string,
    teamObj: any,
  ): Promise<any> => {
    if (!user_id || !cus_id || !price_id) {
      return {
        success: false,
        result: 'Error checking mobile/web trial',
      };
    }
    return (await initAxios())
      ?.post(
        `/payments/mobile-to-web-trial-check/${user_id}/${cus_id}/${price_id}`,
        JSON.stringify(teamObj),
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      });
  },
  getSubscriptionById: async(sub_id: string): Promise<any> =>
    (await initAxios())
      ?.get(`/payments/subscriptions/find/${sub_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default PaymentsAPI;
